import { useAuth } from "../hooks/authContext";
import { Box, Typography, Stack, Skeleton } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useRef, useState, useEffect, lazy, Suspense } from "react";
import "../Style/buttonCss.css";
import RotatingText from "./RotatingText";
import { useCity } from "../hooks/cityContext";
import { useFetchData } from "../generic/useApi";

/* 🔥 Lazy load modal (NO UI CHANGE) */
const RegisterForm = lazy(() => import("../pages/signup"));

const HeroSection = () => {
  const navigate = useNavigate();
  const bgRef = useRef(null);
  const { selectedCity } = useCity();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const { data, isLoading } = useFetchData(
    ["city", selectedCity],
    `/user/getBannersByCity/${selectedCity}`,
    { enabled: !!selectedCity }
  );
console.log(data,"banner data")
  const banner = data?.data?.data || [];

  /* ✅ CDN URL (same as before) */
  const imageUrl = banner[0]?.imageUrl?.replace(
    ".blr1.digitaloceanspaces.com",
    ".blr1.cdn.digitaloceanspaces.com"
  );
console.log(imageUrl,"imageurl")
  return (
    <>
      {open && (
        <Suspense fallback={null}>
          <RegisterForm open={open} handleClose={() => setOpen(false)} />
        </Suspense>
      )}

      {isLoading ? (
        <Box sx={{ width: "100%", height: { xs: "30vh", sm: "40vh", md: "55vh" , lg:"70vh" } }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
          />
        </Box>
      ) : banner?.length > 0 &&
(banner[0]?.isActive === "1" || banner[0]?.isActive === "Active") ? (
        /* ✅ BANNER IMAGE (LCP FIXED) */
      <Box
  sx={{
    width: "100%",
    height: { xs: "30vh", sm: "40vh", md: "55vh", lg: "70vh" },
    overflow: "hidden",
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f5ee",
  }}
>
  <a
    href={banner[0]?.link || "#"}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "block",
      width: "100%",
      height: "100%",
    }}
  >
    <picture
      style={{
        display: "block",
        width: "100%",
        height: "100%",
      }}
    >
      <img
        src={imageUrl}
        alt="Real Estate Banner"
        width="1920"
        height="800"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center",
        }}
      />
    </picture>
  </a>
</Box>
      ) : (
        /* ✅ DEFAULT HERO (UNCHANGED DESIGN) */
        <Box
          sx={{
            position: "relative",
            background: "linear-gradient(to right, #ED213A, #190A05)",
            width: "100%",
            height: { xs: "30vh", sm: "40vh", md: "55vh" ,lg:"70vh"},
            color: "#111",
            px: { sx: 0, md: 2 },
            py: { sx: 0, md: 6 },
            overflow: "hidden",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 0, md: 4 },
          }}
        >
          {/* Background Glow */}
          <Box
            ref={bgRef}
            sx={{
              position: "absolute",
              filter: "blur(100px)",
              zIndex: 0,
              transition: "transform 0.3s ease",
              pointerEvents: "none",
            }}
          />

          {/* Left Image */}
          <Box
            sx={{
              width: { xs: "60%", sm: "40%", md: "35%", lg: "30%" },
              display: "flex",
              justifyContent: { sx: "start", sm: "center" },
              alignItems: { sx: "start", sm: "end" },
              zIndex: 1,
            }}
          >
            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              style={{ width: "100%" }}
            >
              <Box
                component="img"
                src="3DImage.webp"   // ✅ webp version
                alt="Post Property"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                width="1200"
                height="600"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  position: "relative",
                  bottom: { xs: 14, md: 22 },
                }}
              />
            </motion.div>
          </Box>

          {/* Right Text */}
          <Box
            sx={{
              width: { xs: "100%", sm: "50%" },
              height: { xs: "50%", sm: "100%" },
              display: { xs: "none", md: "flex" },
              flexDirection: "column",
              justifyContent: "center",
              alignItems: { xs: "center", md: "left" },
              textAlign: { xs: "center", md: "center" },
              zIndex: 1,
            }}
          >
            <Box sx={{ position: "relative", bottom: { xs: 25, sm: 0 } }}>
              <RotatingText />
            </Box>

            <Typography
              variant="body1"
              mb={3}
              sx={{
                display: { xs: "none", sm: "flex" },
                fontSize: { sm: "0.8rem", md: "0.9rem", lg: "1.2rem" },
                color: "white",
              }}
            >
              List your property in minutes — no charges, no hassle. Reach thousands
              of potential buyers or tenants now.
            </Typography>

            <Stack sx={{ display: { xs: "none", sm: "flex" } }}>
              <button
                className="button"
                style={{
                  width: "fit-content",
                  height: "40px",
                  whiteSpace: "nowrap",
                  fontSize: "1.3rem",
                  fontWeight: 500,
                }}
                onClick={() =>
                  user
                    ? navigate("/post-properties/basic-info")
                    : setOpen(true)
                }
              >
                Post Property
              </button>
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default HeroSection;